"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticStyle: {
      height: "100vh",
      width: "100vw",
      margin: "0",
      padding: "0",
      overflow: "hidden",
      background: "#525659"
    }
  }, [_vm.blobUrl ? _c("object", {
    staticStyle: {
      border: "none",
      display: "block"
    },
    attrs: {
      data: _vm.blobUrl,
      type: "application/pdf",
      width: "100%",
      height: "100%"
    }
  }, [_c("embed", {
    attrs: {
      src: _vm.blobUrl,
      type: "application/pdf",
      width: "100%",
      height: "100%"
    }
  }), _c("div", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      height: "100%",
      gap: "16px",
      color: "#fff"
    }
  }, [_c("p", [_vm._v("Your browser does not support inline PDF viewing.")]), _c("a", {
    staticStyle: {
      color: "#409eff",
      "font-weight": "bold",
      "text-decoration": "underline"
    },
    attrs: {
      href: _vm.rawUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }
  }, [_vm._v("Open PDF directly")])])]) : _c("div", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      height: "100%",
      gap: "16px",
      color: "#fff"
    }
  }, [_vm.error ? _c("div", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c("p", {
    staticStyle: {
      color: "#f56c6c",
      "margin-bottom": "12px"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]), _vm.rawUrl ? _c("a", {
    staticStyle: {
      color: "#409eff",
      "font-weight": "bold",
      "text-decoration": "underline"
    },
    attrs: {
      href: _vm.rawUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }
  }, [_vm._v("Open PDF directly")]) : _vm._e()]) : _c("div", [_c("p", [_vm._v("Loading quotation...")])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;